<template>
  <div>
    <main class="ui--main-detail">
      <section class="--bx">
        <div class="--box">

          <p class="--title" v-html="adata.title">4 Reasons to Make your Home Smart</p>
          <p class="--date" v-html="adata.date_author">January 31, 2022</p>
          <ul class="share-icon-list" style="opacity: 0.965;">
            <li><a :href="share_data.fb" target="_blank"><img src="/static/images/icon-facebook.png" alt=""
                  style="width: 24px;"></a></li>
            <li><a :href="share_data.ld" target="_blank"><img src="/static/images/icon-linkedin.png" alt=""
                  style="width: 24px;"></a></li>
          </ul>
          <div class="--content" v-html="adata.content">
            <!-- <p style="text-align: center;"><img style="width: 70%;" src="/static/images/news/02-20220216.png" alt=""></p>
                  <p>There are several pros to making your space smart by using smart devices. Let's dive into what I consider to be the top 4 pros of integrating smart technology into your living space.</p>
                  <h3>1.Safety</h3>
                  <p>
                      With features such as motion detection and continuous recording, security cameras allow you to keep an eye on your kids, animals, and home all with a click of a button when you are away. Smart locks provide added security to a home. Some smart locks are even enabled for you to create one-time secure passcodes that can be given and then changed to allow limited access to package delivery services or the dog walker. With numerous additional options for safety, security, and peace of mind smart devices can provide you with much needed insight and clarity into what is happening around your home while you're away.
                  </p>
                  <h3>2.Accessibility</h3>
                  <p>
                      Smart spaces can be useful for people with disabilities because they make them more accessible. Components such as motion activation, voice activation, and remote access control are helpful for people who have hearing, vision, or mobility impairment. Devices can be set on a schedule, triggered by motion, or controlled wirelessly which can help empower people with disabilities by providing them with more independence.
                  </p>
                  <h3>3.Energy Savings</h3>
                  <p>
                      Smart devices can be optimized to save you energy and money. Devices with smart capabilities such as thermostats, vents, and room sensors can be placed on schedules and set to use artificial intelligence to optimize your living environment. For example, you can set your thermostat to use less energy while you are away at work. Your smart energy devices will work together to learn your schedule. Once the device has learned your schedule you will arrive home to the ideal temperature having saved energy throughout the day.
                  </p>
                  <h3>4.Customization</h3>
                  <p>
                      Smart gadgets allow you to customize your space. With smart lights and speakers, you can change the atmosphere of a space that appeals to your senses. Smart lights let you customize what color or temperature of light depending on your mood or time of day. You can also program speakers to play music or sounds. Upgrades are also simple due to ease of installation and customization.
                  </p> -->
          </div>
        </div>
        <div class="share-bx">
          <p>Share article</p>
          <ul class="icon-list" style="opacity: 0.965;">
            <li><a :href="share_data.fb" target="_blank"><img src="/static/images/icon-facebook.png" alt=""
                  style="width: 24px;"></a></li>
            <li><a :href="share_data.ld" target="_blank"><img src="/static/images/icon-linkedin.png" alt=""
                  style="width: 24px;"></a></li>
          </ul>
        </div>
        <!-- <div class="submitionForm">
              <div>
                  <img src ="/static/images/Group 687.png"/>
              </div>
              <div>
                  <form class="submitionDetail" method="post" action="mailto:media@smartz.cloud?subject=NewsLetter&body=testing@cc=jianzhang@smartz.cloud">
                      <h1>Stay up to date with Smartz news and Proptech industry insights!</h1>
                      <label style="display:block">Email<span style="color:red">*</span></label>
                      <input required type="email" placeholder="Please enter your email"  style="display:block;width:100%;height:30px; font-size: large;padding-left:10px" autocomplete="off">
                      <button>Subscribe</button>
                  </form>
              </div>
          </div> -->
      </section>
    </main>

    <div class="dialog--box bg" v-if="form_data.show_flag">
      <div class="bx--blank">
        <span class="close-btn" @click="toCloseDialog(0)">+</span>
        <div class="content">
          <p class="title">Request A Demo</p>
          <div class="input-list">
            <div class="input-item">
              <label for="">Name <span style="color: #c62b2b;">*</span></label>
              <input type="text" v-model="form_data.name">
            </div>
            <div class="input-item">
              <label for="">Company Name <span style="color: #c62b2b;">*</span></label>
              <input type="text" v-model="form_data.company">
            </div>
            <div class="input-item">
              <label for="">Email <span style="color: #c62b2b;">*</span></label>
              <input type="text" v-model="form_data.email">
            </div>
            <div class="input-item">
              <label for="">Phone Number <span style="color: #c62b2b;">*</span></label>
              <input type="text" v-model="form_data.phone">
            </div>
            <div class="input-item">
              <label for="">Job Title <span style="color: #c62b2b;">*</span></label>
              <input type="text" v-model="form_data.job">
            </div>
            <div class="input-item">
              <label for="">How many units are in your portfolio?</label>
              <input type="text" v-model="form_data.units">
            </div>
            <div class="input-item w-100">
              <label for="">How did you hear about us?</label>
              <input type="text" v-model="form_data.way">
            </div>
            <div class="input-item w-100">
              <label for="">Anything else you would like us to know?</label>
              <textarea rows="3" v-model="form_data.message"></textarea>
            </div>
            <div class="input-item w-100">
              <button v-if="!dialog.waiting" @click="submitFormData()">Submit</button>
              <button v-else class="disabled" v-html="dialog.text"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { WOW } from "wowjs";
  import Swiper from "swiper";
  import jQuery from "jquery";
  export default {
    name: "detail",
    data() {
      return {
        headerElement: window.vPageHeader,
        footerElement: window.vPageFooter,
        form_data: {
          name: '',
          company: '',
          email: '',
          phone: '',
          job: '',
          units: '',
          way: '',
          message: '',
          show_flag: false,
        },
        dialog: {
          waiting: false,
          count: 30,
          timer: 0,
          text: 'Submit'
        },
        msg: 'sdsd',
        year: 2021,
        open_menu: false,
        words: {
          title: '',
          content: ''
        },
        words2: {
          title: '',
          content: ''
        },
        text_obj: [
          { title: 'Smart Thermostats', text: 'Reduce energy consumption while increasing potential market value through the use of smart thermostats.' },
          { title: 'Smart Sensors', text: 'Be alerted when your smart sensor detects movement from the opening of your door or window.' },
          { title: 'Smart Locks', text: 'Enhance the comfort and security of your tenants with smart locks.' },
          { title: 'Smart Lighting', text: 'Provide tenants with a unique color scheme for your lighting.' },
        ],
        text_obj2: [
          { cont_id: 1, title: 'Improve the Properties and Income', text: ' Tenants are becoming more technology forward and are willing to pay more for apartments that include smart devices which will increase your income.' },
          { cont_id: 2, title: 'Tenants Management', text: 'Screen tenants, create leases, auto schedule rent payments, receive and track the timeline of maintenance requests and repairs directly from our manager portal.' },
          { cont_id: 3, title: 'Maintenance Requests', text: 'Receive and track the timeline of maintenance requests and repairs directly from our manager portal.' },
          { cont_id: 4, title: 'Self Touring and Self Check-in', text: 'Have potential tenants sign up for a time and receive a limited time access code to safely and securely tour your property without you having to be there.' },
          { cont_id: 5, title: 'Environment <br>Monitoring', text: 'Access your security devices all from one platform and get notified if suspicious activity occurs.' },
        ],
        nav_list: [
          { id: 0, text_id: -1, url: '/static/images/home/inner-page/nav-workspace.png', act_url: '/static/images/home/inner-page/nav-workspace.png', content: '/static/images/home/inner-page/Properties.png' },
          { id: 1, text_id: 0, url: '/static/images/home/inner-page/nav-properties.png', act_url: '/static/images/home/inner-page/nav-properties-a.png', content: '/static/images/home/inner-page/Properties.png' },
          { id: 2, text_id: 1, url: '/static/images/home/inner-page/nav-tenants.png', act_url: '/static/images/home/inner-page/nav-tenants-a.png', content: '/static/images/home/inner-page/Tenants.png' },
          { id: 3, text_id: 2, url: '/static/images/home/inner-page/nav-maintenance.png', act_url: '/static/images/home/inner-page/nav-maintenance-a.png', content: '/static/images/home/inner-page/Maintenance.png' },
          { id: 4, text_id: 3, url: '/static/images/home/inner-page/nav-access.png', act_url: '/static/images/home/inner-page/nav-access-a.png', content: '/static/images/home/inner-page/Access.png' },
          { id: 5, text_id: 4, url: '/static/images/home/inner-page/nav-environment.png', act_url: '/static/images/home/inner-page/nav-environment-a.png', content: '/static/images/home/inner-page/Environment.png' },
          { id: 6, text_id: -1, url: '/static/images/home/inner-page/nav-financials.png', act_url: '/static/images/home/inner-page/nav-financials.png', content: '/static/images/home/inner-page/Properties.png' },
          { id: 7, text_id: -1, url: '/static/images/home/inner-page/nav-analytics.png', act_url: '/static/images/home/inner-page/nav-analytics.png', content: '/static/images/home/inner-page/Properties.png' },
          { id: 8, text_id: -1, url: '/static/images/home/inner-page/nav-community.png', act_url: '/static/images/home/inner-page/nav-community.png', content: '/static/images/home/inner-page/Properties.png' },
        ],
        current_index: 1,
        current_index_1: 0,
        auto_play_arr: [1, 2, 3, 4, 5],
        auto_play_timer: 0,
        auto_play_count: 0,
        g_conut: 0,
        mouse_evt: false,
        version_number: `1.0.${parseInt((new Date().getTime()) / (1000 * 60 * 30))}`,
        adata: {
          title: '',
          date_author: '',
          content: '',
        },
        share_data: {
          fb: '',
          ld: '',
          ig: '',
        }
      }
    },
    mounted() {
      new WOW().init();
      this.menuOpt();
      this.dynamicLoad();

      var _self = this;
      // _self.resize();
      window.onresize = function () {
        // _self.resize();
      }

      // this.adata = this.getData(news_list); // news.js 文件引入

      this.year = (new Date()).getFullYear();
    },
    methods: {
      submitFormData() {
        var form_data = this.form_data;
        console.log(form_data);
        var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        var isOk = (form_data.email).trim() != '' &&
          (form_data.name).trim() != '' &&
          (form_data.company).trim() != '' &&
          (form_data.phone).trim() != '' &&
          (form_data.job).trim() != '';
        if (isOk) {
          if (!reg.test(form_data.email)) {
            alert('Email address is invalid');
            return;
          }
          var data = {
            name: form_data.name,
            company: form_data.company,
            email: form_data.email,
            phone: form_data.phone,
            job: form_data.job,
            units: form_data.units,
            way: form_data.way,
            message: form_data.message,
          }
          var _self = this;
          _self.dialog.waiting = true;
          _self.dialog.count = 30;
          _self.dialog.text = 'Submit (' + _self.dialog.count + ')';
          _self.dialog.timer = setInterval(function () {
            _self.dialog.count = _self.dialog.count - 1;
            _self.dialog.text = 'Submit (' + _self.dialog.count + ')';
            if (_self.dialog.count == 0) {
              _self.dialog.waiting = false;
              _self.dialog.text = 'Submit';
              clearInterval(_self.dialog.timer);
            }
          }, 1000);
          // jQuery.post('http://127.0.0.1:7001/api/contact/demo', data, function(res){
          jQuery.post('/api/contact/demo', data, function (res) {
            if (res.result == 'ok') {
              alert('Sent successfully');
              setTimeout(function () {
                _self.dialog.waiting = false
                _self.dialog.text = 'Submit';
                clearInterval(_self.dialog.timer);
              }, 500)
            } else {
              alert('Send failure');
              setTimeout(function () {
                _self.dialog.waiting = false
                _self.dialog.text = 'Submit';
                clearInterval(_self.dialog.timer);
              }, 500)
            }
          })

        } else {
          alert('The required information cannot be empty');
        }

      },
      toCloseDialog(n) {
        this.form_data.show_flag = 1 == n
      },
      openMenu() {
        this.open_menu = !this.open_menu;
        if (this.open_menu) {
          jQuery('.box--menu').slideToggle();
        } else {
          jQuery('.box--menu').slideToggle();
        }
      },

      menuOpt() {
        jQuery('.logo--nav .n-item').hover(function () {
          jQuery(this).find('.list-menu').stop().slideDown();
        },
          function () {
            jQuery(this).find('.list-menu').stop().slideUp();
          })
      },
      jump2link(url) {
        if (url == '') return;
        window.open(url);
      },
      getParam(key) {
        var _url = window.location.search;
        var reg = new RegExp('(\\?|^|&)' + key + '=([^&#]*)(&|$|#)');
        var r = _url.match(reg);
        if (r != null) return unescape(r[2]); return def || '' == def ? def : false;
      },
      getData(arr) {
        var nid = this.getParam('nid');
        nid = nid.replaceAll('/', '');
        // var res = '';
        if (Array.isArray(arr)) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i]['id'] == nid) {
              // res = arr[i]['detail'];
              this.adata.title = arr[i]['title'];
              this.adata.date_author = `${arr[i]['author']}, ${arr[i]['edate']}`;
              this.adata.content = arr[i]['detail'];
              console.log(arr[i]['detail'], "arr[i]['detail'],")
              var page_url = encodeURIComponent(window.location.href);
              var title = arr[i]['title'];
              var sub_title = arr[i]['content'];

              var url = window.location.origin;
              var share_img = `${url}${arr[i]['share_img']}`;

              this.share_data.fb = `https://www.facebook.com/sharer/sharer.php?u=${page_url}&t=${page_url}`;
              this.share_data.ld = `http://www.linkedin.com/shareArticle?mini=true&url=${page_url}&title=${title}`;
              this.share_data.ig = arr[i]['link'];



              jQuery("head meta[property='og:image']").attr({ 'content': share_img });
              jQuery("head title").text(title);

            }
          }
        }
        // return res;
      },
      dynamicLoad() {
        var _self = this;
        var _doc = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', './data/news.js');
        _doc.appendChild(script);
        script.onload = script.onreadystatechange = function () {
          if (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete') {
            // _self.getData(news_list);
            fetch('https://www.smartz.cloud/webapi/getBlogs').then(res => res.json())
              .then(res => {
                console.log(res)
                _self.getData(res.reverse())
              })
          }
          script.onload = script.onreadystatechange = null;
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import '@/assets/css/new-common.scss';

  .ui--main-detail {
    .--bx{
      width: 100%; position: relative; padding: 70px 0 0px; color: #333333;
      .--box {
        width: 90%; max-width: 1280px; margin-left: auto; margin-right: auto;
        .--date{font-size: 24px; color: #999999; margin-bottom: 35px; margin-top:0px}
        .--title{font-size: 42px; color: #333333; margin-bottom: 15px; font-weight: bolder;}
        .--content  {
          p{font-size: 18px; line-height: 28px; margin-bottom: 20px; color: #333333;}
          h3{font-size: 22px; line-height: 30px; margin-bottom: 20px; color: #333333;}
        }
      }
    }
    /* .--bx .--box{width: 90%; max-width: 1280px; margin-left: auto; margin-right: auto;}
    .--bx .--date{font-size: 24px; color: #999999; margin-bottom: 35px; margin-top:0px}
    .--bx .--title{font-size: 42px; color: #333333; margin-bottom: 15px; font-weight: bolder;}
    .--bx .--content p{font-size: 18px; line-height: 28px; margin-bottom: 20px; color: #333333;}
    .--bx .--content h3{font-size: 22px; line-height: 30px; margin-bottom: 20px; color: #333333;} */

    .--bx .share-bx {width: 90%; max-width: 1280px; margin-left: auto; margin-right: auto; margin-top: 65px;}
    .--bx .share-bx p{font-size: 18px; font-weight: bold; margin-bottom: 10px;}
    .--bx .share-bx .icon-list{display: flex; flex-direction: row;}
    .--bx .share-bx .icon-list li{margin-right: 15px;}
    .--bx .share-icon-list{display: flex; flex-direction: row; margin-bottom: 35px;}
    .--bx .share-icon-list li{margin-right: 15px;}
    @media screen and (max-width: 800px) {
        .--bx{padding: 10vw 0 13vw;}
    }    
    [v-cloak]{display: none;}
  }

  .submitionForm {
    width: 100vw;
    background-color: #f2f2f2;
    height: 470px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 350px;
      margin-right: 35px;

    }

    .submitionDetail {
      width: 300px;
      display: flex;
      flex-direction: column;
      transform: translateY(-30px);

      h1 {
        margin-bottom: 30px;
        font-size: 1.7rem;
      }

      label {
        font-weight: bold;
        margin-bottom: 5px;
      }

      input {
        margin-bottom: 30px;
        border: #16adfd 1px solid;
      }

      button {
        height: 50px;
        background-color: #16adfd;
        color: white;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/detail/index.vue